import { FontAwesomeIcon } from "@comparaonline/ui-offer-icons";
import { getEntityIcon, getIconColor } from "@comparaonline/ui-offer-product-attributes";
import { withTheme, WithTheme } from "@material-ui/core/styles";
import React from "react";

import { IIconProps } from "./types";

const BaseIcon: React.FC<IIconProps & WithTheme> = ({ iconCode, theme }) => (
  <FontAwesomeIcon
    icon={getEntityIcon(iconCode)}
    color={getIconColor(theme, iconCode)}
    fixedWidth={true}
  />
);

export const Icon = withTheme()(BaseIcon);
